import React from "react";
import { BLACK, BORDER, FONT, GOLD_DARK, TEXT_FAINT } from "./theme";

// Labeled deck-style stepper: (1) Pick your goal — (2) Where it lives —
// (3) Choose your strategy. Completed steps show a check and are clickable to
// jump back. There is no "finished" step: the strategy saves on step 3.
const STEP_LABELS = [
    "Pick your goal",
    "Where it lives",
    "Choose your strategy",
];

interface WizardStepperProps {
    step: 1 | 2 | 3;
    onStepClick?: (step: 1 | 2 | 3) => void;
}

export function WizardStepper({ step, onStepClick }: WizardStepperProps) {
    return (
        <div
            style={{
                fontFamily: FONT,
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexWrap: "wrap",
                marginBottom: 22,
            }}
        >
            {STEP_LABELS.map((label, i) => {
                const n = (i + 1) as 1 | 2 | 3;
                const done = n < step;
                const active = n === step;
                const clickable = done && !!onStepClick;
                return (
                    <React.Fragment key={label}>
                        <button
                            type="button"
                            disabled={!clickable}
                            onClick={() =>
                                clickable &&
                                onStepClick &&
                                onStepClick(n as 1 | 2 | 3)
                            }
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 7,
                                background: "transparent",
                                border: "none",
                                padding: 0,
                                cursor: clickable ? "pointer" : "default",
                                fontFamily: FONT,
                            }}
                        >
                            <span
                                style={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: "50%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 12,
                                    fontWeight: 700,
                                    background: active || done ? GOLD_DARK : "transparent",
                                    color: active || done ? "#fff" : TEXT_FAINT,
                                    border: `1.5px solid ${active || done ? GOLD_DARK : BORDER}`,
                                }}
                            >
                                {done ? "✓" : n}
                            </span>
                            <span
                                style={{
                                    fontSize: 13,
                                    fontWeight: active ? 700 : 600,
                                    color: active ? BLACK : done ? GOLD_DARK : TEXT_FAINT,
                                }}
                            >
                                {label}
                            </span>
                        </button>
                        {i < STEP_LABELS.length - 1 && (
                            <span
                                style={{
                                    flex: "0 1 42px",
                                    minWidth: 18,
                                    height: 1.5,
                                    background: n < step ? GOLD_DARK : BORDER,
                                }}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
